<template>
  <div
    class="publish-affiliated-panel"
    :style="{ '--publish-notch-position': notchPosition }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "PublishAffiliatedPanel",
  props: {
    notchPosition: {
      type: String,
      default: "50%",
    },
  },
};
</script>

<style lang="less" scoped>
@import "./tokens.less";

.publish-affiliated-panel {
  position: relative;
  z-index: 1;
  margin: 4px @publish-space-card-x 12px;
  padding: 12px;
  background: @publish-subtle-bg;
  border: 0;
  border-radius: 8px;
  box-shadow: none;

  &::before {
    position: absolute;
    top: -5px;
    left: var(--publish-notch-position);
    width: 18px;
    height: 18px;
    background: @publish-subtle-bg;
    border-radius: 3px;
    content: "";
    transform: translateX(-50%) rotate(45deg);
  }
}
</style>

